import { AsyncPipe } from '@angular/common';
import { Observable } from 'rxjs';
import { Component, inject, input, output } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';import { Breakpoint, BreakpointState, MediaQueryService } from '../../../services/media-query.service';
import { IconComponent } from '../../../components/icon/icon.component';
import { FlyoutMenuComponent } from '../../../components/flyout-menu/flyout-menu.component';
import { FlyoutMenuToggleDirective } from '../../../components/flyout-menu/flyout-menu-toggle.directive';
import { IconButtonBackground, IconButtonComponent } from '../../../components/icon-button/icon-button.component';
import { FlyoutMenuItemDirective } from '../../../components/flyout-menu/flyout-menu-item.directive';
import { FileFormat } from '../../../services/export/export.domain';
import { TranslatePipe } from '../../../pipes/translate.pipe';

@Component({
  selector: 'td-wb-toolbar-item-export',
  templateUrl: 'toolbar-item-export.component.html',
  styleUrls: ['toolbar-item-export.component.scss'],
  imports: [
    IconComponent,
    FlyoutMenuComponent,
    FlyoutMenuToggleDirective,
    IconButtonComponent,
    TranslatePipe,
    TranslateDirective,
    AsyncPipe,
    FlyoutMenuItemDirective,
    TranslatePipe
  ]
})
export class ToolbarItemExportComponent {
  private readonly mediaQueryService = inject(MediaQueryService);

  readonly fileFormats = input<Array<FileFormat>>(undefined);
  readonly autoSizeOverride = input<boolean>(true);
  readonly tdWbIconButtonBackground = input<IconButtonBackground>('grey');

  readonly onExport = output<FileFormat>();

  breakpointChanges: Observable<BreakpointState>;

  constructor() {
    if (this.autoSizeOverride()) {
      this.breakpointChanges = this.mediaQueryService.observe(Breakpoint.LT_MD);
    }
  }

  showFormatsDropDown(): boolean {
    const fileFormats = this.fileFormats();
    return Array.isArray(fileFormats) && fileFormats.length > 1;
  }

  export(selectedFileFormat?: FileFormat): void {
    this.onExport.emit(this.getFileFormat(selectedFileFormat));
  }

  private getFileFormat(selectedFileFormat: FileFormat): FileFormat {
    if (selectedFileFormat !== undefined) {
      return selectedFileFormat;
    }
    const fileFormats = this.fileFormats();
    if (Array.isArray(fileFormats) && fileFormats.length > 0) {
      return fileFormats[0];
    }
    return FileFormat.CSV;
  }
}
